export const FALLBACK_IMAGE: string = '/images/no-image.png';
export const REDIRECT_KEY = 'redirect';

export const PORTAL_ACCESS_TOKEN_KEY = process.env.REACT_PORTAL_ACCESS_TOKKEN || '__admin_access_token__';
export const PORTAL_URL_KEY = process.env.REACT_APP_PORTAL || 'https://portal.dev.negocioscuba.net';
export const PORTAL_REFRESH_TOKEN_KEY = process.env.REACT_PORTAL_REFRESH_TOKKEN || '__admin_refresh_token__';
